import styled from 'styled-components';

export const Track = styled.div`
    position: relative;
    min-width: 100%;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    cursor: grab;
`;

export const List = styled.div`
    display: flex;
    flex-wrap: nowrap;
    transition: transform 0.2s linear;
`;
